import React from 'react';
import './EventInfoBox.scss';
import { Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import DateSpan from 'Components/Shared/DateSpan/DateSpan';
import LocationSpan from 'Components/Shared/LocationSpan/LocationSpan';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  firstDate: Date;
  lastDate: Date;
  venueDetails: Julius.Website.VenueDetailViewModel[];
  playLength: number;
  playInformation: string;
  linkWebsite: string;
  linkSpotify: string;
  linkYoutube: string;
  language: string;
  onShowVenueInfo: () => void;
}

const EventInfoBox: React.SFC<IProps> = ({
  firstDate,
  lastDate,
  venueDetails,
  playLength,
  playInformation,
  linkWebsite,
  linkSpotify,
  linkYoutube,
  onShowVenueInfo,
  language,
}) => {

  const playHours = Math.floor(playLength / 60);
  const playMinutes = playLength % 60;
  const isMultipleVenues = venueDetails.length > 1;

  const PlayInfo = () => (
    <div>
      <span>
        <FormattedText 
          style='capitalize bold'
          displayName='längd'
          formattedName='global.duration'
        />&nbsp;
        { playHours > 0 && 
          <> 
            { playHours } 
            <FormattedText
              displayName='tim'
              formattedName='global.hours'
            />
          </> 
        }
        { playMinutes > 0 && 
          <>
            , { playMinutes } 
            <FormattedText
              displayName='min'
              formattedName='global.min'
            />
          </> 
        }
      </span><br />
      { playInformation && 
        <span>({ playInformation })</span> 
      }
    </div>
  );

  const VenueInfo = () => (
    <div>
      <LocationSpan 
        isMultipleVenues={ isMultipleVenues }
        venue={ venueDetails[0].name }
        city={ venueDetails[0].city }
      />
      <br />
      <span className='venue-info' onClick={ onShowVenueInfo }>
        <FormattedMessage 
          id='event.showvenueinfo'
          defaultMessage='Mer information om spelplatsen'
          values={ { venueCount: venueDetails.length } }
        />
      </span>
    </div>
  );

  const LanguageInfo = () => (
    <div className="language-info capitalize">
      { language }
    </div>
  );

  const getHref = (url: string) => {
    return url.startsWith('http') || url.startsWith('spotify:album') ? url : `//${ url }`;
  } 

  return (
    <div className='event-info-box'>
      <FormattedText 
        style='title'
        displayName='Information'
        formattedName='global.information'
      />
      <InfoRow>
        <Icon type='calendar' />
        <DateSpan 
          firstDate={ firstDate }
          lastDate={ lastDate }
          dateFormat='long'
        />
      </InfoRow>
      { playLength > 0 &&
        <InfoRow>
          <Icon type='clock-circle-o' />
          <PlayInfo />
        </InfoRow>
      }
      { venueDetails && venueDetails.length > 0 &&
        <InfoRow>
          <Icon type='environment-o' />
          <VenueInfo />
        </InfoRow>
      }
      { linkWebsite && linkWebsite.length > 0 &&
        <InfoRow>
          <Icon type='home' />
          <a href={ getHref(linkWebsite) } target='_blank'>
            <FormattedText 
              displayName='Hemsida'
              formattedName=''
            />
          </a>
        </InfoRow>
      }
      { linkSpotify && linkSpotify.length > 0 &&
        <InfoRow>
          <div className='logo'><img alt='Spotify logga' src='/spotify.png' /></div>
            <a href={ getHref(linkSpotify) } target='_blank'>
            <FormattedText 
              displayName='Spotify'
              formattedName=''
            />
          </a>
        </InfoRow>
      }
      { linkYoutube && linkYoutube.length > 0 &&
        <InfoRow>
          <Icon type='youtube' />
          <a href={ getHref(linkYoutube) } target='_blank'>
            <FormattedText 
              displayName='Youtube'
              formattedName=''
            />
          </a>
        </InfoRow>
      }
      { language && language.length > 0 && (
        <InfoRow>
          <Icon type='global' />
          <LanguageInfo />
        </InfoRow>
      )}
    </div>
  );
};

interface IInfoRow {
}
const InfoRow: React.SFC<IInfoRow> = ({
  children,
}) => (
  <div className='info-row'>
    { children }
  </div>
);

export default EventInfoBox;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/EventInfoBox/EventInfoBox.tsx